import PropTypes from 'prop-types';

const AuthPropType = PropTypes.shape({
  account_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export default AuthPropType;
